module.exports = __webpack_public_path__ + "media/images/beauty/agnes@3x-6a559d8ca476159541485477d60815f1.jpg";